import { z } from "zod"
import { ArrowRight, Lock } from "lucide-react"

import { Button } from "@/components/ui/button"
import { Form } from "@/components/ui/form"
import { IconInputField } from "@/components/auth/IconInputField"
import { useAuthForm } from "@/lib/use-auth-form"
import { useSession } from "@/lib/session-context"
import { passwordComplexitySchema } from "@/lib/auth-schemas"

const schema = z
  .object({
    password: passwordComplexitySchema,
    password_confirmation: z.string(),
  })
  .refine((data) => data.password === data.password_confirmation, {
    message: "Passwords must match",
    path: ["password_confirmation"],
  })

export function ResetPasswordForm({ token, onSuccess }) {
  const { resetPassword } = useSession()

  const { form, serverError, submit } = useAuthForm({
    schema,
    defaultValues: { password: "", password_confirmation: "" },
    onSubmit: async (values) => {
      await resetPassword({ token, ...values })
      onSuccess?.()
    },
  })

  return (
    <Form {...form}>
      <form onSubmit={submit} className="space-y-5" noValidate autoComplete="off">
        <IconInputField
          form={form}
          name="password"
          label="New Password"
          icon={Lock}
          type="password"
          autoComplete="new-password"
          placeholder="••••••••"
        />

        <IconInputField
          form={form}
          name="password_confirmation"
          label="Confirm Password"
          icon={Lock}
          type="password"
          autoComplete="new-password"
          placeholder="••••••••"
        />

        {serverError ? (
          <p role="alert" className="text-sm font-medium text-destructive">
            {serverError}
          </p>
        ) : null}

        <Button
          type="submit"
          disabled={form.formState.isSubmitting}
          className="mt-4 h-12 w-full gap-2 rounded-xl text-sm font-bold shadow-md shadow-primary/20"
        >
          Reset Password
          <ArrowRight className="h-4 w-4" />
        </Button>
      </form>
    </Form>
  )
}
